import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/Long_Pattern_Footer.jpg",
    alt: "Pattern"
  })
], -1)
const _hoisted_3 = { class: "bg-dark-blue font-roboto" }
const _hoisted_4 = { class: "mx-auto max-w-7xl px-6 pb-6 pt-16 sm:pt-24 lg:px-8 lg:pt-16" }
const _hoisted_5 = { class: "xl:grid xl:grid-cols-3 xl:gap-8" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"space-y-6 text-center sm:text-left\"><img class=\"h-16 mx-auto sm:mx-0 hidden sm:block\" src=\"/img/logos/GetGo_Updated_Logo_Footer.png\" alt=\"Getgo Logo\"><div class=\"hidden sm:flex justify-center sm:justify-start space-x-3\"><a href=\"https://www.instagram.com/getgofund/?next=%2F\" target=\"_blank\" class=\"bg-white p-2 rounded-full text-dark-blue\"><img class=\"h-8 w-8\" src=\"/img/Icons/Insta_Footer.svg\" alt=\"Instagram\"></a><a href=\"https://www.facebook.com/people/GetGo-Fund/61556829002719/\" target=\"_blank\" class=\"bg-white p-2 rounded-full text-dark-blue\"><img class=\"h-8 w-8\" src=\"/img/Icons/Facebook_Footer.svg\" alt=\"Facebook\"></a><a href=\"https://twitter.com/GetGoFund\" target=\"_blank\" class=\"bg-white p-2 rounded-full text-dark-blue\"><img class=\"h-8 w-8\" src=\"/img/Icons/X_Footer.svg\" alt=\"X\"></a><a href=\"https://www.linkedin.com/in/getgo-educational-fund-9143b2301/\" target=\"_blank\" class=\"bg-white p-2 rounded-full text-dark-blue\"><img class=\"h-8 w-8\" src=\"/img/Icons/LinkedIn_Footer.svg\" alt=\"LinkedIn\"></a></div></div>", 1)
const _hoisted_7 = { class: "mt-0 sm:mt-16 grid grid-cols-1 sm:grid-cols-2 gap-8 xl:col-span-2 xl:mt-0 text-center sm:text-left" }
const _hoisted_8 = { class: "md:grid md:grid-cols-2 md:gap-8" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold leading-6 text-white" }, "Get Involved", -1)
const _hoisted_10 = {
  role: "list",
  class: "mt-7 space-y-4 text-white"
}
const _hoisted_11 = ["href", "target"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "mt-10 md:mt-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold leading-6 text-white italic sm:not-italic" }, "Powered By"),
  /*#__PURE__*/_createElementVNode("ul", {
    role: "list",
    class: "mt-4 space-y-4"
  }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://maharishiinstitute.org/",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          class: "h-24 mx-auto sm:mx-0 -mt-4 sm:-mt-0",
          src: "/img/Maharishi_Footer.svg",
          alt: "Maharishi"
        })
      ])
    ])
  ])
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "md:grid md:grid-cols-2 md:gap-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mt-0 sm:mt-10 md:mt-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold leading-6 text-white italic sm:not-italic" }, "Affiliated With"),
    /*#__PURE__*/_createElementVNode("ul", {
      role: "list",
      class: "mt-8 space-y-8"
    }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://feenix.org/",
          target: "_blank"
        }, [
          /*#__PURE__*/_createElementVNode("img", {
            class: "h-8 mx-auto sm:mx-0 -mt-4 sm:-mt-0 mb-8 sm:mb-0",
            src: "/img/Feenix_logo.svg",
            alt: "Feenix"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://wafunda.com/",
          target: "_blank"
        }, [
          /*#__PURE__*/_createElementVNode("img", {
            class: "h-[18px] mx-auto sm:mx-0 -mt-4 sm:-mt-0 mb-8 sm:mb-0",
            src: "/img/logos/wafunda.png",
            alt: "Wafunda"
          })
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("hr", { class: "bg-white w-80 mx-auto mb-7 sm:hidden" }),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-0 sm:mt-10 md:mt-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold leading-6 text-white" }, "Contact"),
    /*#__PURE__*/_createElementVNode("ul", {
      role: "list",
      class: "mt-6"
    }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "mailto:support@getgofund.org",
          class: "text-sm text-white hover:text-gray-300 whitespace-nowrap sm:whitespace-normal xl:whitespace-nowrap"
        }, "Email: support@getgofund.org")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "pt-2" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-white hover:text-gray-300" }, "Phone: +27 (0)21 007 5786")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "mt-8" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "text-white text-lg font-semibold mb-6" }, "About Us"),
        /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-6 text-white" }, "GetGo Fund NPC: 2023/244856/08"),
        /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-6 text-white mt-1" }, "Support Hours:"),
        /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-6 text-white whitespace-nowrap sm:whitespace-normal xl:whitespace-nowrap" }, "Monday to Friday, 9am to 5pm")
      ])
    ])
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"flex sm:hidden justify-center sm:justify-start space-x-4 mt-10\"><a href=\"https://www.instagram.com/getgofund/?next=%2F\" target=\"_blank\" class=\"bg-white p-2 rounded-full text-dark-blue\"><img class=\"h-6 w-6\" src=\"/img/Icons/Insta_Footer.svg\" alt=\"Instagram\"></a><a href=\"https://www.facebook.com/people/GetGo-Fund/61556829002719/\" target=\"_blank\" class=\"bg-white p-2 rounded-full text-dark-blue\"><img class=\"h-6 w-6\" src=\"/img/Icons/Facebook_Footer.svg\" alt=\"Facebook\"></a><a href=\"https://twitter.com/GetGoFund\" target=\"_blank\" class=\"bg-white p-2 rounded-full text-dark-blue\"><img class=\"h-6 w-6\" src=\"/img/Icons/X_Footer.svg\" alt=\"X\"></a><a href=\"https://www.linkedin.com/in/getgo-educational-fund-9143b2301/\" target=\"_blank\" class=\"bg-white p-2 rounded-full text-dark-blue\"><img class=\"h-6 w-6\" src=\"/img/Icons/LinkedIn_Footer.svg\" alt=\"LinkedIn\"></a></div>", 1)
const _hoisted_15 = { class: "mt-16 border-t border-white/10 pt-8 sm:mt-20 lg:mt-24 hidden sm:block" }
const _hoisted_16 = {
  href: "https://wafunda.com/",
  target: "_blank",
  class: "text-xs leading-5 text-white hover:text-gray-300"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("footer", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _hoisted_9,
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.getInvolvedLinks, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", { key: index }, [
                      _createElementVNode("a", {
                        href: item.href,
                        target: (item.name === 'Terms and Conditions' || item.name === 'Privacy Policy') ? '_blank' : null,
                        class: "text-sm leading-6 hover:text-gray-300"
                      }, _toDisplayString(item.name), 9, _hoisted_11)
                    ]))
                  }), 128))
                ])
              ]),
              _hoisted_12
            ]),
            _hoisted_13
          ]),
          _hoisted_14
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("a", _hoisted_16, _toDisplayString($data.currentYear) + " Built By WaFunda", 1)
        ])
      ])
    ])
  ]))
}